import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX } = FiIcons;
const homeLinks = [
  ['About', '#about'],
  ['Current Builds', '#builds'],
  ['Reviews', '#reviews'],
  ['Contact', '#contact']
];
const bniLinks = [
  ['About', '/#about'],
  ['Current Builds', '/#builds'],
  ['Reviews', '/#reviews'],
  ['Contact', '#contact-bni']
];
const bookLinks = [
  ['About', '/#about'],
  ['Current Builds', '/#builds'],
  ['Reviews', '/#reviews'],
  ['Contact', '/bni#contact-bni']
];

function Header({ bniPage = false, bookPage = false }) {
  const [open, setOpen] = useState(false);
  const links = bookPage ? bookLinks : bniPage ? bniLinks : homeLinks;
  const logoHref = bniPage || bookPage ? '/' : '#top';

  return (
    <header className="site-header">
      <nav className="nav-shell" aria-label="Main navigation">
        <a className="wordmark" href={logoHref} onClick={() => setOpen(false)}>
          Perry Dasilva
        </a>
        <button
          className="menu-toggle"
          type="button"
          aria-label="Toggle navigation"
          aria-expanded={open}
          onClick={() => setOpen((current) => !current)}
        >
          <SafeIcon icon={open ? FiX : FiMenu} />
        </button>
        <div className={`nav-links ${open ? 'nav-links-open' : ''}`}>
          {links.map(([label, href]) => (
            <a key={href} href={href} onClick={() => setOpen(false)}>
              {label}
            </a>
          ))}
        </div>
      </nav>
    </header>
  );
}

export default Header;